"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactRouterDom = require("react-router-dom"),
    _Text = _interopRequireDefault(require("../../Text"));

require("./_link.scss");

function Link(a) {
  var b = a.onClick,
      c = a.children,
      d = a.className,
      e = a.button,
      f = a.to;
  return !e && f ? _react["default"].createElement(_reactRouterDom.Link, {
    className: "link",
    to: f
  }, _react["default"].createElement(_Text["default"], {
    className: "link__text",
    link: !0
  }, c)) : _react["default"].createElement("button", {
    className: (0, _classnames["default"])("link", "link--button", d),
    tabIndex: 0,
    type: "button",
    onClick: b
  }, _react["default"].createElement(_Text["default"], {
    link: !0
  }, c));
}

var _default = (0, _react.memo)(Link);

exports["default"] = _default;